/**
 * PostHog Route Tracker
 * 
 * Handles:
 * 1. Pageview tracking on route changes (for SPA navigation)
 * 2. Session recording toggling based on current route
 *    - Only enables recording on /assessment/* and /org-chart/* routes
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { checkSessionRecording, trackPageview } from '../lib/posthog';

const PostHogRouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip pageview on first render (PostHog init already captures initial pageview)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      // Still check session recording on initial load
      checkSessionRecording(location.pathname);
      return;
    }
    
    // Track pageview on route change
    trackPageview(location.pathname);
    
    // Check if session recording should be enabled/disabled
    checkSessionRecording(location.pathname);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PostHogRouteTracker;
